import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import 'bootstrap';
import './assets/app.scss';
import VueGtm from 'vue-gtm';
import VueOnlineProp from "vue-online-prop";
import browserDetect from "vue-browser-detect-plugin";
import i18n from '@/plugins/i18n'
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import snackbar from './mixins/snackbar';
import session from './mixins/session';
import utils from './mixins/utils';
import engagement from './mixins/engagement.js';
import analytics from './mixins/analytics.js';
import agenda from './mixins/agenda.js';
import "firebase/auth";
import VueMeta from 'vue-meta';
import loginHelper from './mixins/loginHelper.js';
import regHelper from './mixins/regHelper.js';

import Environment from "@/components/EnvironmentInit";



Vue.mixin(snackbar)
Vue.mixin(session)
Vue.mixin(utils)
Vue.mixin(engagement)
Vue.mixin(analytics)
Vue.mixin(agenda)
Vue.use(VueMeta)
Vue.mixin(loginHelper)
Vue.mixin(regHelper)

Vue.use(Vuetify, {
	icons: {
		iconfont: 'md',
	},
})
Vue.use(Vuetify, {
	icons: {
		iconfont: 'md',
	},
})

// Vue.http.headers.common['Cross-Origin-Embedder-Policy'] = 'unsafe-none';
// Vue.http.headers.common['Cross-Origin-Opener-Policy'] = 'unsafe-none';

import VModal from 'vue-js-modal';
Vue.use(VueOnlineProp);
//Vue.use(VueScreen);
Vue.use(browserDetect);
Vue.use(VModal)
const interceptor = require('./index.js');
Vue.use(interceptor)
//Vue.use(CircularCountDownTimer)
if (Environment.Instance.includes('prd')) {
	Vue.use(VueGtm, {
		id: 'GTM-PHZM8TF', // Your GTM single container ID or array of container ids ['GTM-xxxxxxx', 'GTM-yyyyyyy']  
		defer: false, // defaults to false. Script can be set to `defer` to increase page-load-time at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible)
		enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
		debug: true, // Whether or not display console logs debugs (optional)
		loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional) 
		vueRouter: router, // Pass the router instance to automatically sync with router (optional)
		ignoredViews: ['Home'] // If router, you can exclude some routes name (case insensitive) (optional)
	});
}
Vue.config.productionTip = false;


export const bus = new Vue();
new Vue({
	router,
	store,
	i18n,
	vuetify: new Vuetify(),
	render: h => h(App)
}).$mount('#app');


